import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

const setFiltersWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
        margin: 8px 0 0;
        @media ${theme.star.mediaQuery.tablet} {
            border-radius: ${theme.star.radius.medium} ${theme.star.radius.medium} 0 0;
            margin: 8px 8px 0;
        }
    `;
    }
    return css``;
};

interface FiltersWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const FiltersWrapper = withConfig(theme => styled('div', { label: 'FiltersWrapper' })<FiltersWrapperPropsType>`
    ${({ variant }): SerializedStyles => setFiltersWrapper(variant, theme)}
    background-color: ${theme.star.headings.sportBanner.bgColor};
    padding: 8px 0 8px 8px;
`);
